import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
// @ts-ignore
import * as CryptoJS from 'crypto-js';
import { Router } from '@angular/router';
import { Auth } from 'src/app/core/models/auth.model';
import { User } from 'src/app/modules/cart-items/model/cart-items';
import { environment } from 'src/environments/environment.dev';
import { AuthStoreService } from 'src/app/core/services/auth-store.service';
export interface LoginResponse {
  success: boolean;
  message: string;
  token: string;
  usuario: {
    id: string;
    username: string | null;
    first_name: string;
    last_name: string | null;
    email: string;
    avatar_url: string | null;
    created_at: string;
    updated_at: string;
    roles: string[];
  };
  roles: string[];
}

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  private readonly API_URL = environment.apiUrl;
  env = environment;
  symmetricKey = this.env.symmetricKey;
  headers: HttpHeaders;

  constructor(private http: HttpClient, private router: Router, private authStore: AuthStoreService) {

    this.headers = new HttpHeaders({ Accept: 'application/json' });
  }

  login(email: string, password: string): Observable<LoginResponse> {
    const body = { email, password };
    return this.http.post<LoginResponse>(`${this.API_URL}/auth/login`, body);
  }
  isAuthenticated() {
    return !!localStorage.getItem('token');
  }

  logOut(): Observable<any> {
    return this.http.get(`${this.API_URL}/logout`).pipe(
      tap(() => {
        this.authStore.clearAuth();
        localStorage.removeItem('sessionID');
        localStorage.removeItem('userData');
        this.router.navigate(['/auth/sign-in']);
      }),
      catchError((error) => {
        this.authStore.clearAuth();
        localStorage.removeItem('sessionID');
        localStorage.removeItem('userData');
        this.router.navigate(['/auth/sign-in']);
        throw error;
      }),
    );
  }
  userLoginGoogle(token: string): Observable<LoginResponse> {
    const body = { token };
    return this.http.post<LoginResponse>(`${this.API_URL}/google`, body);
  }

  handleCredentialResponse(response: any) {
    const googleToken = response.credential;

    this.http.post<any>(this.API_URL + '/google', { token: googleToken })
      .subscribe({
        next: (res) => { console.log('Login OK', res); },
        error: (err) => { console.error('Error', err); }
      });
  }

  register(body: any): Observable<LoginResponse> {
    return this.http.post<LoginResponse>(`${this.API_URL}/register`, body);
  }
}
